/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Stock_Movement_Not_ReadyInputs */

const en_error_stock_movement_not_ready = /** @type {(inputs: Error_Stock_Movement_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The movement cannot go ahead: some lines or warehouses are not right.`)
};

/**
* | output |
* | --- |
* | "The movement cannot go ahead: some lines or warehouses are not right." |
*
* @param {Error_Stock_Movement_Not_ReadyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_stock_movement_not_ready = /** @type {((inputs?: Error_Stock_Movement_Not_ReadyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Stock_Movement_Not_ReadyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_stock_movement_not_ready(inputs)
});